import deliveryRemark from "@/api/delivery/deliveryRemark";

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    async fetch() {
      try {
        const response = await deliveryRemark.fetch();
        return Promise.resolve(response.data);
      } catch(error) {
        return await Promise.reject(error);
      }
    }
  }
}
